import { ISelectedTicket } from '../types/ticket';
import transliterate from './transliterate';

export function getTicketsIdsSet(tickets: ISelectedTicket[]) {
  return new Set(tickets.map((ticket) => ticket.id));
}

export function getPoolTicketsIdsSet(tickets) {
  return new Set(tickets.map((t) => t.ticket_id));
}

export function translateTicket(ticket) {
  return {
    ...ticket,
    label: ticket.label && transliterate(ticket.label),
    sector: ticket.sector && transliterate(ticket.sector),
  };
}
